// AutoGenerated
export class HesapAnketCevapModel {
    hesapModelId!: string;
    anketModelId!: string;
    anketSoruModelId!: string;
    anketSoruSecenekId!: string | null;
    secim!: string | null;
}